import { useEffect, useRef } from 'react';
import { DAY_PERIODS } from '../utils/constants';
import { timeToMinutes } from '../utils/date';

/** Applies a date/time handed over from another screen (e.g. the landing preview) once slots load. */
export default function usePresetSlot(picker, preset) {
  const pending = useRef(preset || null);

  useEffect(() => {
    if (pending.current?.date) picker.selectDate(pending.current.date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const p = pending.current;
    if (!p?.time || picker.slots.loading || picker.slots.date !== p.date) return;
    const slot = picker.slots.items.find((s) => s.time === p.time && s.available);
    if (slot) {
      const m = timeToMinutes(p.time);
      const period = DAY_PERIODS.find((x) => m >= timeToMinutes(x.from) && m < timeToMinutes(x.to));
      if (period) picker.setPeriod(period.key);
      picker.setSelectedTime(p.time);
    }
    pending.current = null;
  }, [picker, picker.slots, picker.selectedDate]);
}
